import styled from "styled-components";

export const FiltersContainer = styled.div`
  border-top: 1px solid #cccccc;
  padding-top: 25px;
  margin-top: 25px;
  width: 100%;
  min-width: 1151px;
`;

export const RowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const DropDownWrapper = styled.div`
  min-width: 33%;
  padding-right: ${({ paddingRight }) => paddingRight || "0"};
  width: ${({ width }) => width || "100%"};
`;

export const LikesBadge = styled.span`
  background: ${({ background }) => background || "#fff"};
  position: absolute;
  border-radius: 4px;
  right: 10px;
  display: inline-block;
  padding: 4px;
  top: 10px;
  margin: 10px 0 0 0;
`;

export const Emoji = styled.span`
  margin-left: 4px;
`;

export const BrandKitMessageWrapper = styled.article`
  line-height: 1.3em;
  font-size: 14px;
`;

export const BrandKitMessage = styled.p`
  margin-top: 5px;
`;
